// src/app/app.module.ts
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxParallaxModule } from '@yoozly/ngx-parallax';
import { NgxScrollTopModule } from 'ngx-scrolltop';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Módulo que contiene navbar, footer, etc.
import { SharedModule } from './shared/shared.module';

// Módulos de “features”
import { PagesModule } from './features/pages/pages.module';
import { StoreModule } from './features/store/store.module';
import { AuthModule } from './features/auth/auth.module';

@NgModule({
  declarations: [
    // ¡Ojo! Aquí solo va el AppComponent, nada más.
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,

    // Librerías externas
    CarouselModule,
    NgxParallaxModule,
    NgxScrollTopModule,
    NgCircleProgressModule.forRoot({}),
    BrowserAnimationsModule,

    // Módulos propios
    SharedModule,
    PagesModule,
    StoreModule,
    AuthModule,
  ],
  providers: [
    provideClientHydration(),
    provideHttpClient(withInterceptorsFromDi()), // Configuración recomendada
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
